import React, { useState, useEffect, useRef } from "react";
import styled from "styled-components";
import frame from "../../../../assets/eventsImages/Frame.svg";
import galleryData from "../../../../assets/eventsImages/galleryData";
import Line from "../../../../assets/eventsImages/Line.svg";
import cancel from "../../../../assets/images/cancel.png";
const ITEMS_PER_PAGE = 12;
const COLLAPSED_HEIGHT = 76;

const Paragraph = styled.p`
  color: #111827;
  font-size: 15px;
  line-height: 1.75;
  margin-bottom: 12px;
  text-align: justify;
`;

const GalleryGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 28px 24px;
  margin-top: 28px;

  @media (max-width: 992px) {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  @media (max-width: 576px) {
    grid-template-columns: 1fr;
  }
`;

const GallerySurface = styled.div`
  background: #ffffff;
  border-radius: 18px;
  padding: 24px;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.04);

  @media (max-width: 576px) {
    padding: 18px;
  }
`;

const EventFooter = styled.div`
  position: absolute;
  bottom: -32px;
  left: 50%;
  transform: translateX(-50%);
  width: 100%;
  max-width: 260px;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 6px;
`;

const EventText = styled.p`
  margin: 0;
  color: #005856;
  font-size: 12px;
  font-weight: 700;
  line-height: 1.2;
  text-align: center;
`;

const LineImage = styled.img`
  width: 60%;
  max-width: 140px;
  display: block;
`;

// const ImageCard = styled.div`
//   position: relative;
//   display: flex;
//   justify-content: center;
//   margin-bottom: 35px;
// `;

const FrameImage = styled.img`
  width: 100%;
  max-width: 260px;
  display: block;
  pointer-events: none;
`;

const EventImage = styled.img`
    position: absolute;
    top: 15%;
    left: 17%;
    width: 66%;
    height: 70%;
    object-fit: cover;
`;

const ImageCard = styled.div`
  position: relative;
  display: flex;
  justify-content: center;
  margin-bottom: 35px;
  cursor: pointer;
`;

const ModalOverlay = styled.div`
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.55);
  display: flex;
  justify-content: center;
  align-items: flex-start;
  z-index: 30000;
  overflow-y: auto;
  padding: 24px;
`;

const ModalContent = styled.div`
  background: #ffffff;
  border-radius: 12px;
  padding: 24px;
  position: relative;
  overflow: auto;
  margin: 0;
  width: clamp(720px, 52vw, 1082px);
  max-height: calc(100vh - 48px);
  display: flex;
  flex-direction: column;
  gap: 18px;

  @media (max-width: 768px) {
    width: min(94vw, 620px);
    max-height: calc(100vh - 32px);
    padding: 18px;
  }
`;

const ModalLeft = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 14px;
`;

const ModalLeftTitle = styled.h2`
  align-self: flex-start;
  color: #183967;
  font-size: 18px;
  font-weight: 700;
  margin: 0;
  line-height: 1.3;
  padding-right: 42px;
`;

const ModalImageWrapper = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  width: min(100%, 800px);
  height: clamp(320px, 56vh, 520px);
  padding: 0;
  overflow: hidden;
  border-radius: 10px;
  background: #f4f8f8;

  @media (max-width: 576px) {
    height: 280px;
  }
`;

const ModalImage = styled.img`
  width: 100%;
  height: 100%;
  object-fit: contain;
  display: block;
`;

const ModalVideo = styled.video`
  width: 100%;
  height: 100%;
  object-fit: contain;
  display: block;
  background: #000000;
`;

const ModalVideoLink = styled.a`
  width: 100%;
  height: 100%;
  border: 0;
  display: block;
  background: #000000;
`;

const CarouselNavButton = styled.button`
  position: absolute;
  top: 50%;
  ${({ $side }) => $side}: 12px;
  transform: translateY(-50%);
  width: 34px;
  height: 34px;
  border: 0;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.92);
  color: #005856;
  font-size: 22px;
  font-weight: 800;
  line-height: 1;
  cursor: pointer;
  box-shadow: 0 6px 18px rgba(0, 0, 0, 0.16);
`;

const CarouselMeta = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  flex-wrap: wrap;
`;

const CarouselCounter = styled.span`
  color: #5f6f73;
  font-size: 12px;
  font-weight: 700;
`;

const CarouselDots = styled.div`
  display: flex;
  align-items: center;
  gap: 6px;
`;

const CarouselDot = styled.button`
  width: 8px;
  height: 8px;
  border: 0;
  border-radius: 50%;
  background: ${({ $active }) => ($active ? "#005856" : "#c8d4d6")};
  padding: 0;
  cursor: pointer;
`;

const ModalBody = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
`;

const DescriptionContainer = styled.div`
  max-height: ${({ $expanded }) => ($expanded ? "180px" : `${COLLAPSED_HEIGHT}px`)};
  overflow-y: auto;
  padding-right: 6px;
  color: #111827;
  font-size: 15px;
  line-height: 1.7;
  text-align: justify;
  transition: max-height 0.2s ease;

  &::-webkit-scrollbar {
    width: 6px;
  }

  &::-webkit-scrollbar-thumb {
    background: rgba(0, 0, 0, 0.18);
    border-radius: 999px;
  }
`;

const ReadMoreButton = styled.button`
  border: none;
  background: transparent;
  color: #8a4b00;
  font-size: 13px;
  font-weight: 700;
  cursor: pointer;
  align-self: flex-start;
  padding: 0;
`;

const CloseModalButton = styled.button`
  position: absolute;
  top: 16px;
  right: 16px;
  width: 34px;
  height: 34px;
  background: #ffffff;
  border: 1px solid #d6d6d6;
  border-radius: 50%;
  font-size: 18px;
  color: #333333;
  cursor: pointer;
  line-height: 1;
  z-index: 1;
`;

const PaginationWrapper = styled.div`
  margin-top: 35px;
  padding: 14px 18px;
  border-radius: 8px;
  background: #f5f5f5;
  display: flex;
  justify-content: flex-end;
  align-items: center;
  gap: 8px;
  flex-wrap: wrap;
`;

const PageButton = styled.button`
  border: ${({ $active }) => ($active ? "1px solid #1a8b94" : "none")};
  background: ${({ $active }) => ($active ? "#ffffff" : "transparent")};
  color: ${({ $active }) => ($active ? "#00656d" : "#595959")};
  border-radius: 5px;
  width: 28px;
  height: 28px;
  cursor: pointer;

  &:disabled {
    opacity: 0.4;
    cursor: not-allowed;
  }
`;

const ShowingText = styled.span`
  color: #595959;
  font-size: 11px;
  margin-left: 10px;
`;

const getMediaSource = (mediaItem) => {
  if (typeof mediaItem === "string") return mediaItem;

  return mediaItem?.src || mediaItem?.url || "";
};

const getMediaType = (mediaItem) => {
  if (typeof mediaItem !== "string" && mediaItem?.type) {
    return mediaItem.type;
  }

  const source = getMediaSource(mediaItem);
  return /\.(mp4|webm|ogg)(\?|#|$)/i.test(source) ? "video" : "image";
};

const getYouTubeVideoId = (source) => {
  if (!source) return "";

  try {
    const parsedUrl = new URL(source, "https://www.nmdfc.org");
    const host = parsedUrl.hostname.replace("www.", "");

    if (host === "youtube.com" || host === "m.youtube.com") {
      if (parsedUrl.pathname.startsWith("/embed/")) {
        return parsedUrl.pathname.split("/").filter(Boolean)[1] || "";
      }

      if (parsedUrl.pathname.startsWith("/shorts/")) {
        return parsedUrl.pathname.split("/").filter(Boolean)[1] || "";
      }

      return parsedUrl.searchParams.get("v") || "";
    }

    if (host === "youtu.be") {
      return parsedUrl.pathname.split("/").filter(Boolean)[0] || "";
    }
  } catch (error) {
    return "";
  }

  return "";
};

const getVideoThumbnail = (mediaItem) => {
  if (typeof mediaItem !== "string" && mediaItem?.thumbnail) {
    return mediaItem.thumbnail;
  }

  const videoId = getYouTubeVideoId(getMediaSource(mediaItem));
  return videoId ? `https://img.youtube.com/vi/${videoId}/hqdefault.jpg` : "";
};

const getEventMedia = (event) => {
  if (Array.isArray(event.media) && event.media.length > 0) {
    return event.media;
  }

  if (event.image) {
    return [
      {
        type: "image",
        src: event.image,
        alt: event.title,
      },
    ];
  }

  return [];
};

const getEventCoverImage = (event) => {
  const eventMedia = getEventMedia(event);
  const firstMedia = eventMedia[0];

  if (getMediaType(firstMedia) === "video") {
    const videoThumbnail = getVideoThumbnail(firstMedia);
    if (videoThumbnail) return videoThumbnail;
  }

  const firstImage = eventMedia.find(
    (mediaItem) => getMediaType(mediaItem) === "image"
  );

  return event.coverImage || getMediaSource(firstImage) || event.image;
};

const getVideoUrl = (source) => {
  if (!source) return "";

  try {
    const parsedUrl = new URL(source, "https://www.nmdfc.org");
    const host = parsedUrl.hostname.replace("www.", "");

    if (host === "youtube.com" || host === "m.youtube.com") {
      if (parsedUrl.pathname.startsWith("/embed/")) return `https://www.youtube.com/watch?v=${parsedUrl.pathname.split("/embed/")[1]}`;

      const videoId = parsedUrl.searchParams.get("v");
      return videoId ? `https://www.youtube.com/watch?v=${videoId}` : source;
    }

    if (host === "youtu.be") {
      const videoId = parsedUrl.pathname.replace("/", "");
      return videoId ? `https://www.youtube.com/watch?v=${videoId}` : source;
    }
  } catch (error) {
    return source;
  }

  return source;
};

const isDirectVideoFile = (source) => /\.(mp4|webm|ogg)(\?|#|$)/i.test(source);

const GalleryContent = () => {
  const [currentPage, setCurrentPage] = useState(1);
  const [selectedEvent, setSelectedEvent] = useState(null);
  const [activeMediaIndex, setActiveMediaIndex] = useState(0);
  const [descriptionExpanded, setDescriptionExpanded] = useState(false);
  const [requiresReadMore, setRequiresReadMore] = useState(false);
  const descriptionRef = useRef(null);

  const totalItems = galleryData.length;
  const totalPages = Math.ceil(totalItems / ITEMS_PER_PAGE);

  const startIndex = (currentPage - 1) * ITEMS_PER_PAGE;

  const visibleEvents = galleryData.slice(
    startIndex,
    startIndex + ITEMS_PER_PAGE
  );
  const selectedEventMedia = selectedEvent ? getEventMedia(selectedEvent) : [];
  const activeMedia = selectedEventMedia[activeMediaIndex];
  const hasMultipleMedia = selectedEventMedia.length > 1;

  const changePage = (page) => {
    if (page < 1 || page > totalPages) return;

    setCurrentPage(page);
  };

  const handleOpenEvent = (event) => {
    setSelectedEvent(event);
    setActiveMediaIndex(0);
    setDescriptionExpanded(false);
  };

  const handleCloseModal = () => {
    setSelectedEvent(null);
    setActiveMediaIndex(0);
    setDescriptionExpanded(false);
    setRequiresReadMore(false);
  };

  const showPreviousMedia = () => {
    if (!selectedEventMedia.length) return;

    setActiveMediaIndex((prevIndex) =>
      prevIndex === 0 ? selectedEventMedia.length - 1 : prevIndex - 1
    );
  };

  const showNextMedia = () => {
    if (!selectedEventMedia.length) return;

    setActiveMediaIndex((prevIndex) =>
      prevIndex === selectedEventMedia.length - 1 ? 0 : prevIndex + 1
    );
  };

  const isLongDescription = requiresReadMore;

  useEffect(() => {
    if (!selectedEvent || !descriptionRef.current) return;

    const descriptionElement = descriptionRef.current;
    setRequiresReadMore(descriptionElement.scrollHeight > COLLAPSED_HEIGHT);
    if (descriptionElement.scrollHeight <= COLLAPSED_HEIGHT) {
      setDescriptionExpanded(false);
    }
  }, [selectedEvent]);

  useEffect(() => {
    if (activeMediaIndex >= selectedEventMedia.length) {
      setActiveMediaIndex(0);
    }
  }, [activeMediaIndex, selectedEventMedia.length]);

  return (
    <GallerySurface>
      {totalItems > 0 ? (
        <>
        <p className="font-bold text-2xl tracking-wide text-[#1b386b]">Our Media Gallery</p>
        
          <GalleryGrid>
            
            {visibleEvents.map((event) => (
              <ImageCard key={event.id} onClick={() => handleOpenEvent(event)}>
                <FrameImage src={frame} alt="" />

                <EventImage
                  src={getEventCoverImage(event)}
                  alt={event.title || "NMDFC Event"}
                />

                <EventFooter>
                  <EventText>{event.title}</EventText>
                  <LineImage src={Line} alt="NMDFC line" />
                </EventFooter>
              </ImageCard>
            ))}
          </GalleryGrid>

          {totalPages > 1 && (
            <PaginationWrapper>
              <PageButton
                disabled={currentPage === 1}
                onClick={() => changePage(currentPage - 1)}
              >
                ‹
              </PageButton>

              {Array.from({ length: totalPages }, (_, index) => (
                <PageButton
                  key={index + 1}
                  $active={currentPage === index + 1}
                  onClick={() => changePage(index + 1)}
                >
                  {index + 1}
                </PageButton>
              ))}

              <PageButton
                disabled={currentPage === totalPages}
                onClick={() => changePage(currentPage + 1)}
              >
                ›
              </PageButton>

              <ShowingText>
                Showing {startIndex + 1} to {Math.min(startIndex + ITEMS_PER_PAGE, totalItems)} of {totalItems} items
              </ShowingText>
            </PaginationWrapper>
          )}
        </>
      ) : (
        <Paragraph>No event images are available currently.</Paragraph>
      )}

      {selectedEvent && (
        <ModalOverlay onClick={handleCloseModal}>
          <ModalContent onClick={(event) => event.stopPropagation()}>
            <CloseModalButton type="button" onClick={handleCloseModal}>
              <img src={cancel} alt="Close" />
            </CloseModalButton>

            <ModalLeft>
              <ModalLeftTitle>{selectedEvent.title}</ModalLeftTitle>
              <ModalImageWrapper>
                {getMediaType(activeMedia) === "video" ? (
                  isDirectVideoFile(getMediaSource(activeMedia)) ? (
                    <ModalVideo controls src={getMediaSource(activeMedia)}>
                      Your browser does not support the video tag.
                    </ModalVideo>
                  ) : (
                    <ModalVideoLink
                      href={getVideoUrl(getMediaSource(activeMedia))}
                      target="_blank"
                      rel="noopener noreferrer"
                      aria-label={`Open ${activeMedia?.title || selectedEvent.title || "event video"} in a new tab`}
                    >
                      <img src={getVideoThumbnail(activeMedia)} alt="" style={{ width: "100%", maxHeight: "90%", objectFit: "contain" }} />
                      Watch video in a new tab
                    </ModalVideoLink>
                  )
                ) : (
                  <ModalImage
                    src={getMediaSource(activeMedia)}
                    alt={activeMedia?.alt || selectedEvent.title}
                  />
                )}

                {hasMultipleMedia && (
                  <>
                    <CarouselNavButton
                      type="button"
                      $side="left"
                      onClick={showPreviousMedia}
                      aria-label="Show previous media"
                    >
                      {"<"}
                    </CarouselNavButton>
                    <CarouselNavButton
                      type="button"
                      $side="right"
                      onClick={showNextMedia}
                      aria-label="Show next media"
                    >
                      {">"}
                    </CarouselNavButton>
                  </>
                )}
              </ModalImageWrapper>

              {hasMultipleMedia && (
                <CarouselMeta>
                  <CarouselCounter>
                    {activeMediaIndex + 1} / {selectedEventMedia.length}
                  </CarouselCounter>
                  <CarouselDots>
                    {selectedEventMedia.map((mediaItem, index) => (
                      <CarouselDot
                        key={`${getMediaSource(mediaItem)}-${index}`}
                        type="button"
                        $active={activeMediaIndex === index}
                        onClick={() => setActiveMediaIndex(index)}
                        aria-label={`Show media ${index + 1}`}
                      />
                    ))}
                  </CarouselDots>
                </CarouselMeta>
              )}
            </ModalLeft>

            <ModalBody>
              <DescriptionContainer
                ref={descriptionRef}
                $expanded={descriptionExpanded}
              >
                {selectedEvent.description}
              </DescriptionContainer>

              {isLongDescription && (
                <ReadMoreButton
                  type="button"
                  onClick={() => setDescriptionExpanded((prev) => !prev)}
                >
                  {descriptionExpanded ? "Show Less" : "Read More"}
                </ReadMoreButton>
              )}
            </ModalBody>
          </ModalContent>
        </ModalOverlay>
      )}
    </GallerySurface>
  );
};

export default GalleryContent;
